import { callApiToServer } from "../callApi";

export async function searchModule(
  authToken,
  searchText,
  skipNumber,
  limitNumber,
  course_id
) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authToken,
    };

    let body = JSON.stringify({
      searchText: searchText,
    });

    let endUrl = "v1/auth/search-module/" + skipNumber + "/" + limitNumber;
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
